import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { qs } from 'url-parse';

import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';

export const useSaveQuickSearch = () => {
  const { searchTerm, ...searchQuery } = useSelector(select.location.getQuery);
  const { ref: articleRef } = useSelector(select.page.getUrlParams);
  const history = useHistory();
  const request = useRequest();

  useEffect(() => {
    if (searchTerm && articleRef) {
      request({
        service: 'help.searchHistory.save',
        method: 'POST',
        body: { searchTerm }
      }).toPromise();

      history.replace({ search: '?' + qs.stringify(searchQuery) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleRef]);
};
